
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic17Off as ObiHydraulic17OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-17-off.js';
 
 
 

 
 export const ObiHydraulic17Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-17-off',
   elementClass: ObiHydraulic17OffElement,
   events: {
     
   }
  });
 
 